var map = {
	"./form.svg": 4142,
	"./gear.svg": 4143,
	"./hat.svg": 4144,
	"./homework.svg": 4145,
	"./journal.svg": 4146,
	"./menu-lines.svg": 3800,
	"./profile.svg": 4147,
	"./school.svg": 4148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4708;